//#region src/version.ts
const VERSION = "2.12.1";
//#endregion
export { VERSION };

//# sourceMappingURL=version.js.map